import React from "react";
import HomePage from "./HomePage";

const App: React.FC = () => {
  return <HomePage />;
};

export default App;
